import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAgent } from '../contexts/AgentContext';

const AgentRoute = ({ children }) => {
  const { agent } = useAgent();
  const loc = useLocation();
  if (!agent) return <Navigate to="/agent/login" state={{ from: loc.pathname }} replace />;
  return children;
};

export default AgentRoute;
